import { DispatchSystem } from 'api/models/Common/JyrneyEnums'
import * as yup from 'yup'

export default yup.object().shape({
  companyName: yup.string().required().label('Company name'),
  registrationNumber: yup.string(),
  alias: yup.string().nullable().label('Company alias'),
  taxi: yup.boolean().label('Taxi'),
  chauffer: yup.boolean().label('Chauffer'),
  rideHail: yup.boolean().label('Ride hail'),
  coach: yup.boolean().label('Coach'),
  carRental: yup.boolean().label('Car rental'),
  microMobility: yup.boolean().label('Micro mobility'),
  termsAndConditions: yup
    .string()
    .nullable()
    .label('Terms and conditions link'),
  dispatchSystem: yup
    .string()
    .nullable()
    .oneOf(Object.keys(DispatchSystem))
    .label('Dispatch System'),
})
